import { queryClient } from "@/client";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { HiOutlineCheckCircle } from "react-icons/hi2";

import { listsQueryKey } from "@/hooks/api/list/useInfiniteLists";
import useSalesyApiClient from "@/hooks/useSalesyApiClient";
import { useToast } from "@/hooks/useToast";

type ListConvertBody = {
  id: string;
};

type UpdateListOptions = {
  displayToast?: boolean;
};

export const useTransformToStatic = ({ displayToast = true }: UpdateListOptions) => {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const { apiClient } = useSalesyApiClient();

  const mutation = useMutation({
    mutationFn: (requestBody: ListConvertBody) => apiClient.listsDynamic.transformToStatic({ id: requestBody.id }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [listsQueryKey] });

      if (displayToast) {
        showToast({
          featuredIcon: { icon: HiOutlineCheckCircle, color: "success" },
          heading: t("list.convert.success"),
        });
      }
    },
  });

  const { mutate, ...mutationResult } = mutation;

  return {
    ...mutationResult,
    transformToStatic: mutate,
  };
};
